import { Component } from 'react'
import * as cn from 'classnames'
import * as styles from 'styles/atoms/legends/LineChartLegend.css'
import { formatUSCurrency } from 'helpers/formatHelpers'
import { SecondaryLine } from 'interfaces/chart'

export type LineLegend = SecondaryLine & {
  style: 'dashed' | 'solid'
  kind?: 'member'
}
type LineChartLegendProps = {
  lines: LineLegend[]
}

class LineChartLegend extends Component<LineChartLegendProps> {
  render () {
    const { lines } = this.props
    const lineChildren = lines.map((line, idx) => {
      const { title, amount, style, kind } = line
      const className = cn(styles.line, {
        [styles.dashed]: style === 'dashed',
        [styles.solid]: style === 'solid',
        [styles.member]: kind === 'member',
      })

      return (
        <div key={ idx } className={ className }>
          <span className={ styles.label }>{ title } </span>
          <span className={ styles.amount }>{ formatUSCurrency(amount) }</span>
        </div>
      )
    })

    return (
      <div className={ styles.chartLineLegend }>
        { lineChildren }
      </div>
    )
  }
}

export default LineChartLegend
